const accessLevels: any = [
  { label: "User", value: 1 },
  { label: "User", value: 2 },
  { label: "User", value: 3 },
  { label: "User", value: 4 },
  { label: "Approver", value: 5 },
  { label: "Approver", value: 6 },
  { label: "Approver", value: 7 },
  { label: "Approver", value: 8 },
  { label: "Admin", value: 9 },
];

export default accessLevels;
